import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import IndexRepository from "../Repositories/IndexRepository";

class IndexBloc {
  listChannel = new Subject();
  updateDepartureChannel = new Subject();
  updateArrivalChannel = new Subject();
  updateReturnChannel = new Subject();
  confirmReturnChannel = new Subject();
  historyChannel = new Subject();
  repository = new IndexRepository();

  constructor() {
    this.listChannel.next({ status: apiResponse.INITIAL });
    this.historyChannel.next({ status: apiResponse.INITIAL });
  }

  fetchList = async (query) => {
    try {
      this.listChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchList(query)
        .then((result) => {
          this.listChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.listChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchUpdateDeparture = async (query) => {
    try {
      this.updateDepartureChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchUpdateDeparture(query)
        .then((result) => {
          this.updateDepartureChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.updateDepartureChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchUpdateArrival = async (query) => {
    try {
      this.updateArrivalChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchUpdateArrival(query)
        .then((result) => {
          this.updateArrivalChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.updateArrivalChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchUpdateReturn = async (query) => {
    try {
      this.updateReturnChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchUpdateReturn(query)
        .then((result) => {
          this.updateReturnChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.updateReturnChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchConfirmReturn = async (query) => {
    try {
      this.confirmReturnChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchConfirmReturn(query)
        .then((result) => {
          this.confirmReturnChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.confirmReturnChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchHistory = async (query) => {
    try {
      this.historyChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchHistory(query)
        .then((result) => {
          this.historyChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.historyChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };
}

export default IndexBloc;
